import * as actionTypes from "../ActionTypes";
import { put, call, takeLatest, takeEvery } from "redux-saga/effects";
import * as api from "./BibleAPI";
import { actionUpdateGlobalLoaderSagaAction } from "../GlobalLoader/GlobalLoaderAction";

function* getBibleLanguagesSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getBibleLanguages, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getBibleCountryLanguagesSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getBibleCountryLanguages, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getBibleVersionsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getBibleVersions, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
    action.payload?.callback?.({
      type: 0,
      message: err?.response?.data?.errors?.[0]?.message || err?.message,
      data: [],
    });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getVersionBooksSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getVersionBooks, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
    action.payload?.callback?.({
      type: 0,
      message: err?.response?.data?.errors?.[0]?.message || err?.message,
      data: {},
    });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getChapterDetailsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getChapterDetails, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getBibleSearchSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getBibleSearch, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getBibleResourceKeySaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getBibleResourceKey, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deleteUserJournalsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteUserJournals, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getUserJournalsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getUserJournals, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getVerseDetailsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getVerseDetails, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getVerseColorSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getVerseColor, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* saveVerseColorSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.saveVerseColor, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* updateVerseColorSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updateVerseColor, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deleteVerseColorSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteVerseColor, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getChapterVideosSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getChapterVideos, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getChapterJournalsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getChapterJournals, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getJournalsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getJournals, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* updateUserStreakSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updateUserStreak, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getUserStreakSummarySaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getUserStreakSummary, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getJournalSpeakersSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getJournalSpeakers, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getJournalsBySpeakerSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getJournalsBySpeaker, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getJournalsByCategorySaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getJournalsByCategory, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* saveJournalSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.saveJournal, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* updateJournalSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updateJournal, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deleteJournalSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteJournal, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* addJournalNoteSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.addJournalNote, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* updateJournalNoteSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updateJournalNote, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deleteJournalNoteSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteJournalNote, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* addJournalNoteItemSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.addJournalNoteItem, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* updateJournalNoteItemSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updateJournalNoteItem, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deleteJournalNoteItemSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteJournalNoteItem, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getBibleSummarySaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.bibleSummary, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

export default function* BibleWatcherSaga() {
  yield takeLatest(actionTypes.GET_BIBLE_LANGUAGES_REQUEST, getBibleLanguagesSaga);
  yield takeLatest(actionTypes.GET_BIBLE_COUNTRY_LANGUAGES_REQUEST, getBibleCountryLanguagesSaga);
  yield takeEvery(actionTypes.GET_BIBLE_VERSIONS_REQUEST, getBibleVersionsSaga);
  yield takeEvery(actionTypes.GET_VERSION_BOOKS_REQUEST, getVersionBooksSaga);
  yield takeEvery(actionTypes.GET_BIBLE_CHAPTER_DETAILS, getChapterDetailsSaga);
  yield takeLatest(actionTypes.GET_BIBLE_SEARCH, getBibleSearchSaga);
  yield takeLatest(actionTypes.GET_BIBLE_RESOURCE_KEY, getBibleResourceKeySaga);
  yield takeEvery(actionTypes.GET_USER_JOURNALS, getUserJournalsSaga);
  yield takeLatest(actionTypes.DELETE_USER_JOURNALS, deleteUserJournalsSaga);
  yield takeEvery(actionTypes.GET_VERSE_DETAILS, getVerseDetailsSaga);
  yield takeEvery(actionTypes.GET_VERSE_COLOR, getVerseColorSaga);
  yield takeLatest(actionTypes.SAVE_VERSE_COLOR, saveVerseColorSaga);
  yield takeLatest(actionTypes.UPDATE_VERSE_COLOR, updateVerseColorSaga);
  yield takeLatest(actionTypes.DELETE_VERSE_COLOR, deleteVerseColorSaga);
  yield takeEvery(actionTypes.GET_CHAPTER_VIDEOS, getChapterVideosSaga);
  yield takeEvery(actionTypes.GET_CHAPTER_JOURNALS, getChapterJournalsSaga);
  yield takeLatest(actionTypes.GET_JOURNALS, getJournalsSaga);
  yield takeLatest(actionTypes.UPDATE_USER_STREAK, updateUserStreakSaga);
  yield takeEvery(actionTypes.GET_USER_STREAK_SUMMARY, getUserStreakSummarySaga);
  yield takeLatest(actionTypes.GET_JOURNAL_SPEAKERS, getJournalSpeakersSaga);
  yield takeLatest(actionTypes.GET_JOURNALS_BY_SPEAKER, getJournalsBySpeakerSaga);
  yield takeLatest(actionTypes.GET_JOURNALS_BY_CATEGORY, getJournalsByCategorySaga);
  yield takeLatest(actionTypes.GET_BIBLE_SUMMARY, getBibleSummarySaga);

  yield takeLatest(actionTypes.SAVE_JOURNAL_REQUEST, saveJournalSaga);
  yield takeLatest(actionTypes.UPDATE_JOURNAL_REQUEST, updateJournalSaga);
  yield takeLatest(actionTypes.DELETE_JOURNAL_REQUEST, deleteJournalSaga);

  yield takeLatest(actionTypes.ADD_JOURNAL_NOTE_REQUEST, addJournalNoteSaga);
  yield takeLatest(actionTypes.UPDATE_JOURNAL_NOTE_REQUEST, updateJournalNoteSaga);
  yield takeLatest(actionTypes.DELETE_JOURNAL_NOTE_REQUEST, deleteJournalNoteSaga);

  yield takeEvery(actionTypes.ADD_JOURNAL_NOTE_ITEM_REQUEST, addJournalNoteItemSaga);
  yield takeEvery(actionTypes.UPDATE_JOURNAL_NOTE_ITEM_REQUEST, updateJournalNoteItemSaga);
  yield takeEvery(actionTypes.DELETE_JOURNAL_NOTE_ITEM_REQUEST, deleteJournalNoteItemSaga);
}
